/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._7ehi1x61%3Afocus%7Bbox-shadow%3A0%200%200%20var(--ds-border-width%2C1px)%20var(--ds-border-focused%2C%234688ec)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._858u1v1w%3Afocus%7Bborder-color%3Avar(--ds-border-focused%2C%234688ec)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19bv1b66%7Bpadding-left%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._n3td1b66%7Bpadding-bottom%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._u5f312x7%7Bpadding-right%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ca0q1b66%7Bpadding-top%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._k48p1wq8%7Bfont-weight%3Avar(--ds-font-weight-medium%2C500)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._vchhusvi%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._12y31o36%7Boutline-width%3Amedium%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1qu2glyw%7Boutline-style%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._12ji1r31%7Boutline-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko12b0%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19itno8c%7Bborder%3Avar(--ds-border-width%2C1px)%20solid%20var(--ds-border-input%2C%238c8f97)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c8fhey%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19pkx0bf%7Bmargin-top%3Avar(--ds-space-negative-100%2C-8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16jlkb7n%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1osq%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._zulp1b66%7Bgap%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19it145i%7Bborder%3Avar(--ds-border-width%2C1px)%20solid%20transparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i7vkz%7Bheight%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb7vkz%7Bwidth%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1h6o%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1h6o%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o9zidpf%7Bflex-shrink%3A0%7D");
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { bind } from 'bind-event-listener';
import { useIntl } from 'react-intl';
import { IconButton } from '@atlaskit/button/new';
import type { EmojiProvider } from '@atlaskit/emoji';
import { ResourcedEmoji } from '@atlaskit/emoji/element';
import Form, { Field } from '@atlaskit/form';
import ViewAllIcon from '@atlaskit/icon/core/align-text-left';
import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import CrossIcon from '@atlaskit/icon/core/cross';
import DeleteIcon from '@atlaskit/icon/core/delete';
import EditIcon from '@atlaskit/icon/core/edit';
import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import MoreIcon from '@atlaskit/icon/core/show-more-horizontal';
import { ButtonItem, MenuGroup } from '@atlaskit/menu';
import { fg } from '@atlaskit/platform-feature-flags';
import { Popup } from '@atlaskit/popup';
import { Box } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';
import type { Space } from '@atlassian/rovo-spaces/controllers/space-store/types';
import { useDeleteSpace } from '@atlassian/rovo-spaces/services/useDeleteSpace';
import { useGetSpaceConversations } from '@atlassian/rovo-spaces/services/useGetSpaceConversations';
import { useListSpaces } from '@atlassian/rovo-spaces/services/useListSpaces';
import { useRenameSpace } from '@atlassian/rovo-spaces/services/useRenameSpace';
import { DeleteSpaceModal } from '@atlassian/rovo-spaces/ui/DeleteSpaceModal';
import { createEmojiProvider } from '@atlassian/rovo-spaces/utils/emoji-provider';
import { Z_INDEX_POPUP_COMPONENTS } from '../../../common/constants';
import { usePinnedConversations } from '../../../common/hooks/use-pinned-conversations';
import type { Conversation, ConversationListProps } from '../../../common/types';
import type { ButtonMenuItemProps } from '../../../common/ui/button-menu-item';
import { LinkMenuItem } from '../../../common/ui/link-menu-item';
import { ChatListItem } from '../chat-list-items';
import { ExpandableMenuItem } from '../expandable-menu-item';
import { GenerativeSpaceIcon } from './generative-space-icon';
import messages from './messages';
const SPACES_LIMIT = 5;
export type SpaceMenuItemsProps = Pick<ConversationListProps, 'onConversationRename' | 'onConversationDelete' | 'onConversationPinToggle' | 'pinnedConversationSummary' | 'conversations' | 'onSelectConversation' | 'currentConversation'> & {
  cloudId: string;
  isADSNavigationEnabled: boolean;
  onSelectSpace?: (space: Space) => void;
  selectedSpaceId?: string;
  product: string;
  experienceId: string;
  isNewAllConversationScreenEnabled?: boolean;
  isSpinnerOverlayConversationIconEnabled?: boolean;
  /**
   * When true, renders the new task-aware design for conversation list items
   * inside the space. Should mirror the value passed to `ChatListMenuItems`.
   * Controlled by the `rovo_chat_enable_tasks` FG.
   */
  isNewDesignEnabled?: boolean;
  onSelectRecommendedSpaces?: () => void;
  isRecommendedSpacesSelected?: boolean;
  isViewAllSpacesSelected?: boolean;
  onSpaceDelete?: (space: Space) => void;
  /** Called when the user confirms a rename. newName is the trimmed new name. */
  onSpaceRename?: (space: Space, newName: string) => void;
  /**
   * The host's "start a new chat" handler — same callback as the new-chat
   * button at the top of the side nav. When the user successfully deletes
   * the space they are currently viewing, this is invoked automatically so
   * the host returns the user to a fresh chat (rather than leaving them on
   * a now-deleted view). Hosts that don't pass `selectedSpaceId` will not
   * trigger this behaviour.
   */
  onNewChatButtonClick?: ButtonMenuItemProps['onClick'];
  /**
   * Called after a space is successfully created via the Create Space modal.
   *
   * **Contract:** the HOST owns the optimistic store update. This component
   * does NOT call `addSpace` itself — it just forwards the event upward.
   * See the matching docstring on `RovoSideNavigationProps.onSpaceCreated`
   * for the full contract and the regression-bug context.
   */
  onSpaceCreated?: (space: import('@atlassian/rovo-spaces/controllers/space-store/types').CreateSpaceResponse, emojiId?: string) => void;
  /**
   * Called when the user clicks the "View all spaces" link rendered as a
   * sibling under the Spaces section (mirrors the existing "View all agents"
   * pattern in `agents-items`).
   *
   * Rendering of the link is gated INSIDE this component by the
   * `rovo_chat_spaces_fe` feature gate (not by the presence of this callback),
   * so hosts can pass it unconditionally without risking accidental exposure
   * of an ungated feature. When the gate is off, the link is hidden even if a
   * callback is provided.
   */
  onViewAllSpacesClick?: () => void;
  renderRecommendedSpacesItem?: (item: React.ReactNode) => React.ReactNode;
};
export const SpaceMenuItems = ({
  cloudId,
  isADSNavigationEnabled,
  onSelectSpace,
  selectedSpaceId,
  product,
  experienceId,
  isNewAllConversationScreenEnabled = false,
  isSpinnerOverlayConversationIconEnabled = false,
  isNewDesignEnabled = false,
  conversations,
  currentConversation,
  onConversationRename,
  onConversationDelete,
  onConversationPinToggle,
  pinnedConversationSummary,
  onSelectConversation,
  onSelectRecommendedSpaces,
  isRecommendedSpacesSelected = false,
  isViewAllSpacesSelected = false,
  onSpaceDelete,
  onSpaceRename,
  onNewChatButtonClick,
  onViewAllSpacesClick,
  renderRecommendedSpacesItem
}: SpaceMenuItemsProps): JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const {
    spaces,
    isLoading
  } = useListSpaces({
    cloudId,
    product,
    experienceId
  });
  const emojiProvider = useMemo(() => createEmojiProvider(cloudId), [cloudId]);
  const limitedSpaces = spaces.slice(0, SPACES_LIMIT);
  const shouldShowViewAllSpaces = spaces.length > 0;
  if (isLoading) {
    return <>
				<Spinner size="small" label={formatMessage(messages.loadingLabel)} />
			</>;
  }
  const recommendedSpacesItem = <LinkMenuItem isADSNavigationEnabled={isADSNavigationEnabled} href="#" isSelected={isRecommendedSpacesSelected} testId="rovo-chat-sidenav-recommended-spaces" onClick={e => {
    e.preventDefault();
    onSelectRecommendedSpaces?.();
  }} elemBefore={<GenerativeSpaceIcon />}>
			{formatMessage(messages.recommendedSpaces)}
		</LinkMenuItem>;
  const renderedRecommendedSpacesItem = renderRecommendedSpacesItem ? renderRecommendedSpacesItem(recommendedSpacesItem) : recommendedSpacesItem;
  return <>
			{renderedRecommendedSpacesItem}
			{limitedSpaces.map(space => <SpaceMenuItem key={space.id} space={space} cloudId={cloudId} product={product} experienceId={experienceId} allConversations={conversations} currentConversation={currentConversation} isSelected={space.id === selectedSpaceId} isADSNavigationEnabled={isADSNavigationEnabled} onSelectSpace={onSelectSpace} emojiProvider={emojiProvider} isNewAllConversationScreenEnabled={isNewAllConversationScreenEnabled} isSpinnerOverlayConversationIconEnabled={isSpinnerOverlayConversationIconEnabled} isNewDesignEnabled={isNewDesignEnabled} onConversationRename={onConversationRename} onConversationDelete={onConversationDelete} onConversationPinToggle={onConversationPinToggle} pinnedConversationSummary={pinnedConversationSummary} onSelectConversation={onSelectConversation} onSpaceDelete={onSpaceDelete} onSpaceRename={onSpaceRename} onNewChatButtonClick={(onNewChatButtonClick as (() => void) | undefined)} />)}
			{shouldShowViewAllSpaces && onViewAllSpacesClick && fg('rovo_chat_spaces_fe') && <LinkMenuItem isADSNavigationEnabled={isADSNavigationEnabled} isSelected={isViewAllSpacesSelected} onClick={e => {
      e.preventDefault();
      onViewAllSpacesClick();
    }} href="#" elemBefore={<ViewAllIcon label="" />}>
					{formatMessage(messages.viewAllSpacesLabel)}
				</LinkMenuItem>}
		</>;
};
type SpaceMenuItemProps = Pick<ConversationListProps, 'onConversationRename' | 'onConversationDelete' | 'onConversationPinToggle' | 'pinnedConversationSummary' | 'onSelectConversation' | 'currentConversation'> & {
  space: Space;
  cloudId: string;
  product: string;
  experienceId: string;
  allConversations: Conversation[];
  isSelected: boolean;
  isADSNavigationEnabled: boolean;
  onSelectSpace?: (space: Space) => void;
  emojiProvider: Promise<EmojiProvider>;
  isNewAllConversationScreenEnabled: boolean;
  isSpinnerOverlayConversationIconEnabled: boolean;
  isNewDesignEnabled: boolean;
  onSpaceDelete?: (space: Space) => void;
  /** Called when the user confirms a rename. newName is the trimmed new name. */
  onSpaceRename?: (space: Space, newName: string) => void;
  /**
   * Host's "start a new chat" handler. Invoked automatically after a successful
   * delete IF this menu item represents the currently-selected space, so the
   * user is taken off the now-deleted view.
   */
  onNewChatButtonClick?: () => void;
};
const SPACE_TESTID_PREFIX = 'rovo-nav-space-item';
const renameStyles = {
  renameForm: "_19it145i _1e0c1txw",
  innerForm: "_zulp1b66 _1bsb1osq _1e0c1txw _4cvr1h6o",
  textFieldContainer: "_16jlkb7n _19pkx0bf",
  textField: "_11c8fhey _19itno8c _2rko12b0 _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _vchhusvi _k48p1wq8 _ca0q1b66 _u5f312x7 _n3td1b66 _19bv1b66 _858u1v1w _7ehi1x61"
};
const spaceItemStyles = {
  emojiTile: "_1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb7vkz _4t3i7vkz"
};
const SpaceMenuItem = ({
  space,
  cloudId,
  product,
  experienceId,
  allConversations,
  currentConversation,
  isSelected,
  isADSNavigationEnabled,
  onSelectSpace,
  emojiProvider,
  isNewAllConversationScreenEnabled,
  isSpinnerOverlayConversationIconEnabled,
  isNewDesignEnabled,
  onConversationRename,
  onConversationDelete,
  onConversationPinToggle,
  pinnedConversationSummary,
  onSelectConversation,
  onSpaceDelete,
  onSpaceRename,
  onNewChatButtonClick
}: SpaceMenuItemProps): JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const [fetchEnabled, setFetchEnabled] = useState(false);
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [localSpaceName, setLocalSpaceName] = useState(space.name);
  const formRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const {
    deleteSpace
  } = useDeleteSpace({
    cloudId,
    product,
    experienceId,
    onSuccess: () => {
      // Notify the host first so any host-side bookkeeping (analytics,
      // pubsub, etc.) runs before we trigger the navigation reset below.
      onSpaceDelete?.(space);
      // If the user just deleted the space they were viewing, return them
      // to a fresh chat using the host's existing new-chat handler. This
      // reuses whatever side-effects the host already implements for the
      // new-chat button (e.g. publishing `space-deselected`, navigating
      // to the chat root, etc.) so each host gets the right UX without
      // having to wire any additional callback.
      if (isSelected) {
        onNewChatButtonClick?.();
      }
    }
  });
  const {
    renameSpace
  } = useRenameSpace({
    cloudId,
    product,
    experienceId,
    onSuccess: (updatedSpace, newName) => onSpaceRename?.(updatedSpace, newName)
  });
  const onRenameBtnClicked = useCallback(() => {
    setIsMoreMenuOpen(false);
    setLocalSpaceName(space.name);
    setIsEditing(true);
  }, [space.name]);
  const onSubmitRename = useCallback((value: string) => {
    const trimmed = value.trim();
    if (!trimmed) {
      setIsEditing(false);
      return;
    }
    setIsEditing(false);
    void renameSpace(space.id, trimmed);
  }, [space.id, renameSpace]);
  const onCancelRename = useCallback(() => {
    setIsEditing(false);
  }, []);
  useEffect(() => {
    if (!isEditing) {
      setLocalSpaceName(space.name);
    }
  }, [isEditing, space.name]);
  useEffect(() => {
    if (isEditing) {
      inputRef.current?.focus();
    }
  }, [isEditing]);
  useEffect(() => {
    if (!isEditing) {
      return;
    }
    const handleClickOutside = (event: Event) => {
      if (formRef.current && !formRef.current.contains((event.target as Node))) {
        onCancelRename();
      }
    };
    const unbind = bind(window, {
      type: 'mousedown',
      listener: handleClickOutside,
      options: {
        capture: true
      }
    });
    return unbind;
  }, [isEditing, onCancelRename]);
  const {
    conversationPage
  } = useGetSpaceConversations({
    spaceId: space.id,
    cloudId,
    product,
    experienceId,
    enabled: fetchEnabled
  });
  const onSpaceItemClick = useCallback((event: React.MouseEvent) => {
    event.preventDefault();
    onSelectSpace?.(space);
  }, [onSelectSpace, space]);
  const onChevronClick = useCallback(() => {
    setFetchEnabled(true);
  }, []);
  const isPinnedChatsEnabled = fg('rovo_chat_pinned_fe');
  const icon = space.emoji ? <Box xcss={spaceItemStyles.emojiTile} aria-hidden="true">
			<ResourcedEmoji emojiId={{
      id: space.emoji,
      shortName: ''
    }} emojiProvider={emojiProvider} fitToHeight={16} />
		</Box> : <FolderClosedIcon label="" />;
  // Merge API-returned space conversations with chat-store conversations that have
  // `rovoSpaceId === space.id`. Chat-store data is preferred because it carries the
  // up-to-date optimistic name and `lastMessage` (just-sent prompt). The optimistic
  // chat-store entry uses a client-generated UUID while the API entry uses the
  // backend-assigned ID — these are linked by the optimistic conversation's
  // `backendConversationId` field (set after the FINAL_RESPONSE arrives), which lets
  // us dedupe so only one row appears per logical conversation.
  const baseConversations = React.useMemo(() => {
    const apiConversations = conversationPage?.conversations ?? [];
    const localSpaceConversations = (allConversations ?? []).filter(c => c.rovoSpaceId === space.id);
    // Build lookup maps:
    //  - localById: by the client UUID (matches API id only after a refresh)
    //  - localByBackendId: by the backend-assigned id captured from FINAL_RESPONSE
    const localById = new Map(localSpaceConversations.map(c => [c.id, c]));
    const localByBackendId = new Map(localSpaceConversations.filter(c => Boolean(c.backendConversationId)).map(c => [(c.backendConversationId as string), c]));
    const consumedLocalIds = new Set<string>();
    const mergedFromApi = apiConversations.map(apiConvo => {
      // Try to match by client UUID first (after a full reload), then by
      // backendConversationId (current session, optimistic still alive).
      const local = localById.get(apiConvo.id) ?? localByBackendId.get(apiConvo.id);
      if (!local) {
        return apiConvo;
      }
      consumedLocalIds.add(local.id);
      // Prefer local optimistic data for fields that change as the user types/sends.
      return {
        ...apiConvo,
        // Keep the API id so the row remains stable across refresh.
        id: apiConvo.id,
        name: local.name ?? apiConvo.name,
        lastMessage: local.lastMessage ?? apiConvo.lastMessage,
        lastMessageType: local.lastMessageType ?? apiConvo.lastMessageType,
        lastMessageTimestamp: local.lastMessageTimestamp ?? apiConvo.lastMessageTimestamp,
        lastAgentMessageStatus: local.lastAgentMessageStatus ?? apiConvo.lastAgentMessageStatus,
        currentTask: local.currentTask ?? apiConvo.currentTask,
        isPinned: apiConvo.isPinned ?? local.isPinned,
        pinnedAt: apiConvo.pinnedAt ?? local.pinnedAt
      };
    });
    // Any local space conversations not yet returned by the API (e.g. brand-new
    // optimistic ones still streaming, or whose backend id wasn't matched above).
    const localOnly = localSpaceConversations.filter(c => !consumedLocalIds.has(c.id));
    return [...localOnly, ...mergedFromApi];
  }, [conversationPage, allConversations, space.id]);
  const pinnedCountConversations = React.useMemo(() => [...(allConversations ?? []), ...baseConversations], [allConversations, baseConversations]);
  const {
    applyOptimisticPinnedState,
    compareConversationsByPinnedState,
    handleConversationPinToggle,
    pinLimitError,
    dismissPinLimitError
  } = usePinnedConversations({
    conversations: baseConversations,
    pinnedCountConversations,
    pinnedConversationSummary,
    isPinnedChatsEnabled,
    onConversationPinToggle,
    getConversationForPinToggle: conversation => conversation.backendConversationId ? {
      ...conversation,
      id: conversation.backendConversationId
    } : conversation
  });
  const conversations = React.useMemo(() => {
    if (!isPinnedChatsEnabled) {
      return baseConversations;
    }
    return baseConversations.map(conversation => {
      return applyOptimisticPinnedState(conversation);
    }).sort(compareConversationsByPinnedState);
  }, [applyOptimisticPinnedState, baseConversations, compareConversationsByPinnedState, isPinnedChatsEnabled]);
  const moreButton = <Popup testId={`${SPACE_TESTID_PREFIX}-more-popup-${space.id}`} isOpen={isMoreMenuOpen} onClose={() => setIsMoreMenuOpen(false)} zIndex={Z_INDEX_POPUP_COMPONENTS} placement="bottom-end" content={() => <MenuGroup>
					<ButtonItem testId={`${SPACE_TESTID_PREFIX}-rename-${space.id}`} iconBefore={<EditIcon label="" />} onClick={onRenameBtnClicked}>
						{formatMessage(messages.moreMenuRenameLabel)}
					</ButtonItem>
					<ButtonItem testId={`${SPACE_TESTID_PREFIX}-delete-${space.id}`} iconBefore={<DeleteIcon label="" color={"var(--ds-icon-danger, #C9372C)"} />} onClick={() => {
      setIsMoreMenuOpen(false);
      setIsDeleteModalOpen(true);
    }}>
						{formatMessage(messages.moreMenuDeleteLabel)}
					</ButtonItem>
				</MenuGroup>} trigger={triggerProps => <IconButton {...triggerProps} testId={`${SPACE_TESTID_PREFIX}-more-${space.id}`} icon={() => <MoreIcon label="" size="small" />} appearance="subtle" spacing="compact" onClick={e => {
    e.preventDefault();
    e.stopPropagation();
    setIsMoreMenuOpen(prev => !prev);
  }} label={formatMessage(messages.moreMenuLabel)} />} />;

  // Shared inner content for both form variants
  const renameFormInner = <>
			<Box xcss={renameStyles.textFieldContainer}>
				<Field name="spaceName" defaultValue={localSpaceName}>
					{({
          fieldProps
        }) => <input {...fieldProps} ref={inputRef} aria-label={formatMessage(messages.moreMenuRenameLabel)} onKeyDown={(e: React.KeyboardEvent) => {
          if (e.key === 'Escape') {
            onCancelRename();
          }
        }} data-testid={`${SPACE_TESTID_PREFIX}-name-edit-${space.id}`} className={ax([renameStyles.textField])} />}
				</Field>
			</Box>
			<IconButton icon={iconProps => <CheckMarkIcon {...iconProps} color={"var(--ds-icon-accent-green, #22A06B)"} />} type="submit" appearance="subtle" shape="circle" spacing="compact" label={formatMessage(messages.confirmRenameLabel)} testId={`${SPACE_TESTID_PREFIX}-rename-confirm-${space.id}`} />
			<IconButton icon={iconProps => <CrossIcon {...iconProps} color={"var(--ds-icon-accent-red, #C9372C)"} />} type="button" onClick={onCancelRename} appearance="subtle" shape="circle" spacing="compact" label={formatMessage(messages.cancelRenameLabel)} testId={`${SPACE_TESTID_PREFIX}-rename-cancel-${space.id}`} />
		</>;
  const renameForm = <div ref={formRef} className={ax([renameStyles.renameForm])}>
			{fg('platform-design_system_team-form_conversion') ? <Form onSubmit={(data: {
      spaceName: string;
    }) => {
      onSubmitRename(data.spaceName);
    }} formProps={{
      class: renameStyles.innerForm
    }}>
					{renameFormInner}
				</Form> : <Form onSubmit={(data: {
      spaceName: string;
    }) => {
      onSubmitRename(data.spaceName);
    }}>
					{({
        formProps
      }) => <form {...formProps} className={ax([renameStyles.innerForm])}>
							{renameFormInner}
						</form>}
				</Form>}
		</div>;
  return <React.Fragment>
			{/* DeleteSpaceModal is always mounted so its state is preserved regardless of isEditing */}
			<DeleteSpaceModal space={space} isOpen={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)} onDeleteConfirm={deleteSpace} />
			{isEditing ? renameForm : <>
					<ExpandableMenuItem title={localSpaceName} isADSNavigationEnabled={isADSNavigationEnabled} href="#" isSelected={isSelected} onClick={onSpaceItemClick} onExpansionToggle={onChevronClick} elemBefore={icon} actionsOnHover={moreButton}>
						{conversations.map((conversation, i) => <ChatListItem key={conversation.id} conversation={conversation} testIdDisambiguator={`space-${space.id}-${i}`} isSelected={conversation.id === currentConversation?.id} isADSNavigationEnabled={isADSNavigationEnabled} isNewAllConversationScreenEnabled={isNewAllConversationScreenEnabled} isSpinnerOverlayConversationIconEnabled={isSpinnerOverlayConversationIconEnabled} isNewDesignEnabled={isNewDesignEnabled} onSelectConversation={c => onSelectConversation(c, isADSNavigationEnabled)} onConversationRename={onConversationRename} onConversationDelete={onConversationDelete} onConversationPinToggle={isPinnedChatsEnabled && onConversationPinToggle ? handleConversationPinToggle : undefined} isPinnedChatsEnabled={isPinnedChatsEnabled} pinLimitError={pinLimitError?.conversationId === conversation.id ? {
          maxPinnedConversations: pinLimitError.maxPinnedConversations
        } : undefined} onDismissPinLimitError={() => {
          dismissPinLimitError(conversation.id);
        }} spaces={[]} isLoadingSpaces={false} spaceEmojiProvider={emojiProvider} />)}
					</ExpandableMenuItem>
				</>}
		</React.Fragment>;
};